import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  text: string;
  name: string;
  location: string;
  image: string;
}
const TESTIMONIALS: Testimonial[] = [{
  text: 'Pensé que nunca más iba a volver a comer pan. Me sorprendió muchísimo la variedad.',
  name: 'Marta G.',
  location: 'Córdoba',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  text: 'Las recetas son fáciles y los ingredientes se consiguen en cualquier lado.',
  name: 'Jorge P.',
  location: 'Rosario',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  text: 'Por fin encontré opciones que realmente me gustan.',
  name: 'Lucía R.',
  location: 'La Plata',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200&h=200'
}, {
  text: 'Lo uso todas las semanas. Cambió mi forma de cocinar.',
  name: 'Daniel S.',
  location: 'Mendoza',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200&h=200'
}];
export function Testimonials() {
  return <section className="py-14 md:py-20 px-5 bg-gray-50" data-id="element-162">
      <div className="max-w-5xl mx-auto" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-164">
          <h2 className="text-3xl md:text-5xl font-serif font-black text-gray-900" data-id="element-165">
            LO QUE DICEN QUIENES YA LA ESTÁN USANDO
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-166">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-md shadow-gray-200/50 border border-gray-100 flex flex-col items-center text-center" data-id="element-167">
              <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover mb-3 shadow-sm ring-2 ring-green-50" data-id="element-168" />
              <div className="flex text-accent mb-3" data-id="element-169">
                {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 fill-current" data-id="element-170" />)}
              </div>
              <p className="text-base md:text-lg font-serif font-medium text-gray-800 leading-snug mb-4" data-id="element-171">
                "{t.text}"
              </p>
              <div data-id="element-172">
                <p className="text-sm font-bold text-gray-900" data-id="element-173">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-174">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}